export enum FeatureToggle {
  communitiesBanMember = 'FEATURE_COMMUNITIES_BAN_MEMBER',
  communitiesChangeCoverImage = 'FEATURE_COMMUNITIES_CHANGE_COVER_IMAGE'
}
